module.exports = __webpack_public_path__ + "static/media/piano.f078d546.svg";